import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { CommonTarget } from './common-targeting';

export const JobFunction = ({ jobTargets, negativeJobTargets }) => {
  const i18n = useContext(I18nContext);

  return (
    <CommonTarget label={_TL_('Job')} includedData={jobTargets} excludedData={negativeJobTargets} singularText={i18n.getString(_TL_('job function'))} pluralText={i18n.getString(_TL_('job functions'))} />
  );
};

JobFunction.propTypes = {
  jobTargets: PropTypes.arrayOf(PropTypes.shape({})),
  negativeJobTargets: PropTypes.arrayOf(PropTypes.shape({})),
};

JobFunction.defaultProps = {
  jobTargets: [],
  negativeJobTargets: [],
};
